import Vue from 'vue'
import Vuex from 'vuex'
import { userKey, urlSignal, urlApi, avisoErro } from '@/config/global'
import axios from 'axios'
import Swal from 'sweetalert2'

Vue.use(Vuex)

function fetchInstituicao(state) {
    axios.get(`${urlApi}/Instituicao/Get`, {})
        .then(res => {
            if (res.data.success) {
                var instituicao = res.data.data;
                state.instituicao = {
                    nrCpfCnpj: instituicao.nrCpfCnpj,
                    nmExibicao: instituicao.nmExibicao,
                    urlImagem: instituicao.urlImagem,
                    urlImagemS3: instituicao.urlImagemS3,
                    urlImagemSistema: instituicao.urlImagemSistema,
                    urlImagemSistemaS3: instituicao.urlImagemSistemaS3,
                };
            } else {
                avisoErro("Não foi possível carregar os dados da instituição.");
            }
        })
        .catch(() => {
            avisoErro("Não foi possível carregar os dados da instituição.");
        });
}

const store = new Vuex.Store({
    state: {
        // variaveis globais
        user: null,
        hubConection: null,
        isAdmContrato: false,
        isAdmin: false,
        tpPessoa: null,
        lstNormas: null,
        instituicao: null,
        dtFimContrato: null,

        showModalSenha: false,
        showModalDados: false,
        showModalDadosInstituicao: false,
        showModalMetodo: false,
        showModalNormativa: false,
        showManualUsuario: false,

        reload: false,
    },
    getters: {
        // get das variaveis
        
        getUser(state) {
            return state.user;
        },
        getIsAdmContrato(state) {
            return state.isAdmContrato;
        },
        getIsAdmin(state) {
            return state.isAdmin;
        },

        getHubConection(state) {
            return state.hubConection;
        },

        getLstNormas(state) {
            return state.lstNormas;
        },

        getShowModalSenha(state) {
            return state.showModalSenha;
        },
        getShowModalDados(state) {
            return state.showModalDados;
        },
        getShowModalDadosInstituicao(state) {
            return state.showModalDadosInstituicao;
        },
        getShowModalMetodo(state) {
            return state.showModalMetodo;
        },
        getShowModalNormativa(state) {
            return state.showModalNormativa;
        },
        getShowManualUsuario(state) {
            return state.showManualUsuario;
        },
        getReload(state) {
            return state.reload;
        },

        getInstituicao(state) {
            return state.instituicao;
        },

        getDtFimContrato(state) {
            return state.dtFimContrato;
        }
    },
    mutations: {
        // troca valores das variaveis
        setUser(state, user) {
            state.user = user
            if (user) {
                
                localStorage.setItem(userKey, JSON.stringify(user))
                axios.defaults.headers.common['Authorization'] = `Bearer ${user.accessToken}`

                state.isAdmContrato = user.usuario.isAdmContrato;
                state.isAdmin = user.usuario.isAdmin;
                state.tpPessoa = user.usuario.tpPessoa;

                // withAutomaticReconnect reduz a janela em que notificações são perdidas:
                // o SignalR não guarda mensagens enviadas com o socket caído.
                var connection = new window.signalR.HubConnectionBuilder().withUrl(`${urlSignal}notificacaohub?p_dsLogin=` + user.usuario.dsLogin, { accessTokenFactory: () => user.accessToken }).withAutomaticReconnect().build();
                state.hubConection = connection;
                state.hubConection.start().then(function () {
                    //console.log('Connetado!');
                }).catch(function (err) {
                    return console.error('Erro: ', err.toString());
                });

                state.hubConection.onclose(async () => {
                    setTimeout(function () {
                        console.log('Tentando Reconectar!');
                        state.hubConection.start();
                    }, 5000);
                });

                state.hubConection.on("DesconectaUsuario", function () {
                    axios.get(`${urlApi}/Auth/revoke`)
                    .then(function () {
                        localStorage.removeItem(userKey);
                        delete axios.defaults.headers.common['Authorization'];
                        state.hubConection = null;

                        Swal.fire({
                            title: 'Sessão encerrada',
                            html: `
            Um outro dispositivo acessou o SollAI utilizando o seu login e senha, recomendamos que você altere sua senha para impedir que outra pessoa acesse o SollAI utilizando seu usuário.`,
                            icon: 'error',
                            showCancelButton: false,
                            confirmButtonColor: '#6E7881',
                            confirmButtonText: 'Fechar',
                        }).then(async () => {
                            location.reload();
                        });
                    })
                    .catch(() => {
                        console.log("Erro ao desconectar o usuário")
                    });
                });
                fetchInstituicao(state);
            } else {
                localStorage.removeItem(userKey)
                delete axios.defaults.headers.common['Authorization']

                state.hubConection = null;
                state.dtFimContrato = null;
            }
            
        },

        setDtFimContrato(state, dtFimContrato) {
            state.dtFimContrato = dtFimContrato || null;
        },

        refreshUserProfile(state, { usuario, idContrato, tpPessoa, flCortesia }) {
            if (!state.user) return

            state.user = {
                ...state.user,
                usuario: {
                    ...usuario,
                    idContrato,
                    tpPessoa,
                    flCortesia,
                },
            }
            localStorage.setItem(userKey, JSON.stringify(state.user))
        },

        setUsuario(state, usuario) {
            if (state.user) {
                state.user.usuario = usuario
            }
        },

        setUsuarioApi(state, usuario) {
            if (state.user) {
                state.user.usuarioApi = usuario
            }
        },

        setHubConection(state,n_conection) {
            state.hubConection = n_conection
        },

        setLstNormas(state, n_lstNormas) {
            state.lstNormas = n_lstNormas
        },
        
        setModal(state, obj) {
            switch (obj.tpModal) {
                case "ModalSenha":
                    state.showModalSenha = obj.show;
                    break;

                case "ModalDados":
                    state.showModalDados = obj.show;
                    break;

                case "DadosInstituicao":
                    state.showModalDadosInstituicao = obj.show;
                    break;

                case "ModalMetodo":
                    state.showModalMetodo = obj.show;
                    break;

                case "ModalNormativa":
                    state.showModalNormativa = obj.show;
                    break;

                case "ManualUsuario":
                    state.showManualUsuario = obj.show;
                    break;

            }
        },

        setReload(state) {
            state.reload = !state.reload;
        },

        setNormativas(state) {
            axios.get(`${urlApi}/Norma/Get`, {})
                .then(res => {
                    if (res.data.success) {
                        let normativas = [];
                        for (let i = 0; i < res.data.data.rows.length; i++) {
                            let item = res.data.data.rows[i];

                            if (item.nmNorma) {
                                item.dsNome = item.nmNorma
                            } else if (item.nmArquivo == null || item.nmArquivo == "") {
                                var nomeArquivo = item.urlArquivo.split('/');
                                if (nomeArquivo.length > 0) {
                                    //item.dsNome = nomeArquivo[nomeArquivo.length - 1].slice(7);
                                    item.dsNome = nomeArquivo[nomeArquivo.length - 1];
                                }
                            } else {
                                item.dsNome = item.nmArquivo;
                            }

                            normativas.push(item);
                        }
                        state.lstNormas = normativas
                    } else {
                        avisoErro("Não foi possível carregar as normativas.");
                    }
                })
                .catch(() => {
                    avisoErro("Não foi possível carregar a normativa.");
                });
        },

        setInstituicao(state) {
            fetchInstituicao(state);
        },

    },
    actions: {
        // logicas de trocar valores
        
    }
});

export default store;